import styled from "styled-components";
import { TextBaseBold } from "./TextBase";

import { mobile } from "styles/breakpoints";

export const TextForButton = styled(TextBaseBold)`
  font-size: 1rem;
  font-weight: 700;

  @media ${mobile} {
    font-size: 0.875rem;
  }
`;